import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { ViewBlacklistRequest } from './viewblacklistrequest';

export class ViewBlacklistAPI extends SixdeeCRBTAPI<ViewBlacklistRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/view-black-list
        return "view-black-list";
    }

    getRequestData()
    {
        return "clientTxnId=11092020"+"&"+
               "language="+ this.getRequest().getViewBlacklistRequest().getLanguage() +"&"+
               "aPartyMsisdn="+ this.getRequest().getViewBlacklistRequest().getAPartyMsisdn() +"&"+
               "channelId="+ this.getRequest().getViewBlacklistRequest().getChannelId() +"&"+
               "serviceId="+ this.getRequest().getViewBlacklistRequest().getServiceId() +"&"+
               "activityId="+ this.getRequest().getViewBlacklistRequest().getActivityId() +"&"+
               "rbtMode="+ this.getRequest().getViewBlacklistRequest().getRbtMode();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/blacklist/viewblacklist/viewblacklistapi.tsx